import { tv } from 'tailwind-variants'

export const levelPanelVariants = tv({
  base: ['relative', 'rounded-xl'],
  variants: {
    accentColor: {
      none: '',
      yellow: 'shadow-yellow-top-accent',
      green: 'shadow-green-top-accent',
      blue: 'shadow-blue-top-accent',
      pink: 'shadow-pink-top-accent'
    }
  },
  defaultVariants: {
    accentColor: 'none'
  }
})
